<template>
  <div :class="$style.wrapper">
    <div :class="$style.spinner" />
    <p :class="$style.text">{{ $t(loaderKey) }}</p>
  </div>
</template>
<script>
import { mapState } from 'vuex'

export default {
  name: 'TheLoader',
  computed: {
    ...mapState(['loaderKey']),
  },
}
</script>
<style lang="scss" module>
.wrapper {
  display: flex;
  flex-direction: column;
  align-items: center;
  gap: 24px;
  padding: 0 16px;
}
.spinner {
  width: 56px;
  height: 56px;
  border: 5px solid rgba(255, 255, 255, 0.2);
  border-top-color: #3dffc0;
  border-radius: 50%;
  animation: spin 0.9s linear infinite;
}
.text {
  font-size: 18px;
  font-weight: 600;
  color: #fff;
  text-align: center;
}
@keyframes spin {
  to {
    transform: rotate(360deg);
  }
}
</style>
